"use strict";
var ACC;
ACC.checkout = {

	_autoload: [
		"bindCheckInit",
		["summaryViewAdjustment", $("#summaryContent")],
		"checkoutSummaryAnimate",
		"bindForms",
		"checkoutFormsValidation",
		"bindSavedPayments",
		"giftCardPayments",
		"checkOutUrlChange",
		"bindEnterEvent",
		"bindGtmCheckoutSteps",
		"bindGtmPaymentSteps",
        "bindGaAddShippingInfo",
        "bindGaAddPaymentInfo",
		["savedCreditCard", $("#savedPaymentList").length],
		["createSpinerContainer", $("#checkout-payment-section").length],
		"toggleCheckoutAriaControls",
        "bindVoucherChanges"
	],

	bindCheckInit: function () {
        window.addEventListener('pageshow', (event) => {
            if (window.location.href.includes('/login/checkout') && window.ACC.externalEmailValidationConfig.ENABLED === 'true') {
				$('#checkoutLoginSubmit').prop('disabled',true);
            }
			// On browser back/forward navigation, enable the submit button if the guest email is present, ensuring the tick icon and button state persist without re-validating.
			const emailInput = document.querySelector("#j_username");
            if (window.location.href.includes('/login/checkout/guest') &&
            emailInput &&
            emailInput.value.trim()) {
				$('#checkoutLoginSubmit').prop('disabled', false);
            }
		});

		if ('checkoutSummaryError' in sessionStorage) {
			getUserErrorMsgs();
		}

		$('.delivery-name-price:first').click(function() {
			const isChecked = $('#HomeDelivery').val()?true:false;
			if (isChecked) {
				clearValidationMsgs();
			}
		})

		// Hide the Click and Collect store selection if we are on the checkout page and the ClickNCollect radio button is not present.
		if (window.location.href.includes('checkout') && !($('#ClickNCollect').length)) {
					$('#clickAndCollectStoreSelection').hide();
				}

		if (document.location.href.indexOf('checkout') === -1){
			clearValidationMsgs();
		}

		$('#deliveryMethodSubmit,#collectionDetailsFormSubmit').click(function () {
			clearValidationMsgs();
        })

		if ($("#checkoutTitle-paymentMethod").hasClass("active")) {
			document.onvisibilitychange = function () {
				if (document.visibilityState === 'visible') {
					getValidationMessage();
				}
			}
		}

		var userIsGuest = 'userIsGuest',
			$checkoutLoginForm = $('#checkoutLoginForm'),
			$guestCheckbox = $('#checkoutLoginGuestCheckbox'),
			$passwordField = $('#j_password'),
			$passwordFieldLabel = $checkoutLoginForm.find(
				'.control-label.sign-in-font-bold'
			),
			cartEntriesError = false;

		function getValidationMessage() {
			const validateUrl = `${window.ACC.config.encodedContextPath}/checkout/validateCart`;
			$.ajax(validateUrl, {
				dataType: 'json',
				timeout: 500,
				headers: {
					'content-type': 'text/plain',
					'X-Requested-With': 'XMLHttpRequest'
				},
				success: function (data) {
                    if (data) {
                        const response = JSON.parse(data);
                        if (response?.errorMessage) {
                            sessionStorage.setItem('checkoutSummaryError', response.errorMessage);
                            redirectToDelivery();
                        }
                    }
				}
			});
		}

		function getUserErrorMsgs() {
			if ('checkoutSummaryError' in sessionStorage) {
				const errorText = sessionStorage.getItem('checkoutSummaryError');
				$('#globalMessages').html(`<div class="global-messages-container" id="errorMessage">
					<div class="message-box u-m-20 message-box--error">
						<span class="message-box__icon message-box__icon--error"></span>
						<p class="message-box__text">${errorText}</p>
					</div>
				</div>`);
			}
		}

		function redirectToDelivery() {
			window.location.replace(`${window.ACC.config.encodedContextPath}/checkout/multi/delivery-method/choose?edit=true`);
		}

		function clearValidationMsgs() {
			if ('checkoutSummaryError' in sessionStorage) {
				sessionStorage.removeItem('checkoutSummaryError');
				$("#globalMessages").html('');
			}
		}

		function enablePasswordInput() {
			$passwordField.attr('disabled', false);
			$passwordFieldLabel.removeClass('checked');
		}

		function disablePasswordInput() {
			$passwordField.attr('disabled', true);
			$passwordFieldLabel.addClass('checked');
		}

		function isGuest() {
			try {
				return localStorage.getItem(userIsGuest);
			} catch (e) {
				return false;
			}
		}

		function toggleGuestCheckout(e) {
			var formAction;

			if ($guestCheckbox.is(':checked')) {
				disablePasswordInput();
				formAction = '/login/checkout/guest';

				try {
					localStorage.setItem(userIsGuest, true);
				} catch (e) {
					// silently fail
				}
			} else {
				enablePasswordInput();
				formAction = '/checkout/j_spring_security_check';

				try {
					localStorage.removeItem(userIsGuest);
				} catch (e) {
					// silently fail
				}
			}

			$checkoutLoginForm.attr('action', ACC.config.encodedContextPath + formAction);
		}

		function setCheckboxState() {
			if ($guestCheckbox.length) {
				$guestCheckbox.off('change').on('change', toggleGuestCheckout);

				if (isGuest()) {
					$guestCheckbox[0].setAttribute('checked', 'checked');
					$guestCheckbox.trigger('change');
				}
			}
		}

		/**
		 * Bind checkbox click handler
		 * and set the initial state of the checkbox
		 */
		setCheckboxState();


		// Alternative checkout flows options
		$('.doFlowSelectedChange').change(function() {
			if ('multistep-pci' == $('#selectAltCheckoutFlow').attr('value')) {
				$('#selectPciOption').css('display', '');
			} else {
				$('#selectPciOption').css('display', 'none');
		}
		});

		$("#addAnotherVoucherLink").on("click", function (e){
			e.preventDefault();
			$("#newVouchers").show();
			$("#voucherCode").val('');
		});

		$('.continueShoppingButton').click(function (){
			var checkoutUrl = $(this).data("continueShoppingUrl");
			window.location = checkoutUrl;
		});


		$('.expressCheckoutButton').click(function(){
			document.getElementById("expressCheckoutCheckbox").checked = true;
		});

		$(document).on("change",".confirmGuestEmail,.guestEmail",function(){

			  var orginalEmail = $(".guestEmail").val();
			  var confirmationEmail = $(".confirmGuestEmail").val();

			  if(orginalEmail === confirmationEmail){
			    $(".guestCheckoutBtn").removeAttr("disabled");
			  }else{
			     $(".guestCheckoutBtn").attr("disabled","disabled");
			  }
		});

		$('.checkoutButton').click(function ()
		{
			var checkoutUrl = $(this).data("checkoutUrl");

			cartEntriesError = ACC.pickupinstore.validatePickupinStoreCartEntires();
			if (!cartEntriesError)
			{
				var expressCheckoutObject = $('.express-checkout-checkbox');
				if(expressCheckoutObject.is(":checked"))
				{
					window.location = expressCheckoutObject.data("expressCheckoutUrl");
				}
				else
				{
					var flow = $('#selectAltCheckoutFlow').attr('value');
					if ( flow == undefined || flow == '')
					{
						// No alternate flow specified, fallback to default behaviour
						window.location = checkoutUrl;
					}
					else
					{
						// Fix multistep-pci flow
						if ('multistep-pci' == flow)
						{
						flow = 'multistep';
						}
						var pci = $('#selectPciOption').attr('value');

						// Build up the redirect URL
						var redirectUrl = checkoutUrl + '/select-flow?flow=' + flow + '&pci=' + pci;
						window.location = redirectUrl;
					}
				}
			}
			return false;
		});
	},

	// Compenate for Design requirements not possible with CSS.
	summaryViewAdjustment: function() {
		var $orderDetailsItem = $("#summaryContent [data-node='orderdetailsitem']");
		var $parent = $orderDetailsItem.parent();
		var maxHeight = $parent.css("max-height");
		var height;
		if($orderDetailsItem.length > 2) {
			// Adjust height to be x2.5 $orderDetailsItem
			height = $orderDetailsItem.eq(0).outerHeight(true) + $orderDetailsItem.eq(1).outerHeight(true) + ($orderDetailsItem.eq(2).outerHeight() / 2);
			if(height > Number(maxHeight.replace("px", ""))) {
				$parent.css("max-height", String(height) + "px");
			}
		}
		else {
			// Remove CSS max height to make sure no scroll.
			$parent.css("max-height", "none")
		}
	},

	checkoutSummaryAnimate: function(){

		$(document).on("click","#openSummaryContent",function(e){
			e.preventDefault();
			if ($(window).width() < 980) {
				var $divId = $('#summaryContent');
				var $linkId = $('#openSummaryContent');
				var $iconObj = $(this).find('.icon');
				var $titleWrapper = $('.summary-title-wrapper');
				if ($divId.is(':hidden') === true){
                    // setting aria-expanded before the animation or delay attribute, as Android TalkBack reads the aria-expanded state immediately when the button is activated, before any animation or delayed attribute update.
                    $linkId.attr('aria-expanded', true);
					$titleWrapper.addClass('border-bottom-light');
					$divId.slideDown("slow", function(){
						$iconObj.removeClass('icon-down-open-mini').addClass('icon-up-open-mini');
						if ($(window).width() > 768) {
							$('.scroll-pane').jScrollPane();
						}
					});
				} else {
                    // setting aria-expanded before the animation or delay attribute, as Android TalkBack reads the aria-expanded state immediately when the button is activated, before any animation or delayed attribute update.
                    $linkId.attr('aria-expanded', false);
					$divId.slideUp("slow", function(){
						$titleWrapper.removeClass('border-bottom-light');
						$iconObj.removeClass('icon-up-open-mini').addClass('icon-down-open-mini');
					});
				}
			}
		});

		if ($('.checkout-order-details-items-list').length){
			ACC.global.detectWindowResize('checkout');
    	}
	},

	bindForms: function(){

		$(document).on("click","#addressSubmit",function(e){
			e.preventDefault();
			$('#tjxAddressForm').submit();
		});

		$(document).on("click", "#collectionDetailsFormSubmit", function(e) {
		    e.preventDefault();
		    var CC_FORM = '#tjxClickCollectForm .form-group';
		    var $ccFormItem = $(CC_FORM + ' input');
		    var inputValCheck = 0;

		    for (var i = 0; i < $ccFormItem.length; i++) {
		        if ($ccFormItem[i]['value']) {
		            ++inputValCheck;
		        }
		    }

		    if ($(CC_FORM).hasClass('has-error') || inputValCheck < $ccFormItem.length) {
		        // error
		    } else {
		        // ok
		        $('form[name="collectionDetailsForm"]').submit();
		    }
		});

        $(document).on("click", "#cpCollectionDetailsFormSubmit", function(e) {
		    e.preventDefault();
		    var CC_FORM = '#tjxCollectionPointForm .form-group';
		    var $ccFormItem = $(CC_FORM + ' input');
		    var inputValCheck = 0;

		    for (var i = 0; i < $ccFormItem.length; i++) {
		        if ($ccFormItem[i]['value']) {
		            ++inputValCheck;
		        }
		    }

		    if ($(CC_FORM).hasClass('has-error') || inputValCheck < $ccFormItem.length) {
		        // error
		    } else {
		        // ok
		        $('form[name="cpCollectionDetailsForm"]').submit();
		    }
		});

		$(document).ready(function(){
			window.ACC.checkout.bindEmailMarketingPreferences();
			if($('.address-loadmore-block').hasClass('open')){
				$('.address-loadmore-link').hide();
			}

			if($('.address-detail-block').is(':visible')) {
				$('.address-loadmore-link').hide();
			}

			if($('#tjxWpBillingAddressForm, #tjxPaymentsBillingAddressForm').find('.form-group').hasClass('has-error')){
				$('.address-loadmore-link').hide();
				$('.address-loadmore-block').show();
				$('.address-loadmore-block').addClass('open');
			}

			$('#address-country').closest('.form-select').addClass('full-width');

            if($('.modal .checkout-delivery-add-address').length === 0 && $('#address-line1').val()) {
                $('.address-loadmore-link').trigger('click');
            }
		});
	},

	checkoutFormsValidation: function(){
		var $checkStepsFormGroup = $(".checkout-steps .form-group");
		if ($checkStepsFormGroup.hasClass('has-error') === true ) {
			$checkStepsFormGroup.find('input:not([type="radio"])').siblings('label').before ('<i class="icon icon-cancel-circled error"></i>');
			$checkStepsFormGroup.find('.form-select label').before ('<i class="icon icon-cancel-circled error"></i>');
			$checkStepsFormGroup.find("input").addClass('form-error');

			// Set aria-invalid to "true" for all fields that returned with errors
			$checkStepsFormGroup.filter('.has-error').find('input').attr('aria-invalid', 'true');
		}

		if($('.checkout-container select').length){
			var $selectClass = $('.checkout-container select');

			$selectClass.each(function(){
				var $this = $(this);
				if ($this.find("option:nth-child(1)").attr('selected')){
					$this.addClass('select-default-color');
				} else {
					$this.removeClass('select-default-color');
				}
			});
		}

	},

	bindSavedPayments: function(){
		$(document).on("click",".js-saved-payments",function(e){
			e.preventDefault();

			ACC.colorbox.open("",{
				href: "#savedpayments",
				inline:true,
				width:"320px"
			});
		});
	},

	giftCardPayments: function(){
		$('#billingWrapper').on("click",".submit-giftcard-success",function(e){
			$('.submit-giftcard-success').bind('click', false);
			e.preventDefault();
			var btnhref = $(this).data('href');

			var $form = $("#worldPayBillingAddressForm, #tjxPaymentDetailsForm"),
				checkoutUrl = $("#orderConfirmationRedirectUrl").val(),
                invalidVoucherRedirectUrl = $("#invalidVoucherRedirectUrl").val();
			$.ajax({
				type: "POST",
				data: $form.serialize(),
				url: btnhref,
				success: function(response) {
					$.each(response, function(key, value) {
                        if (key == 'orderID') {
                            ACC.common.removeFromLocalStorage(ACC.common.localCartJsonKey)
                            var location = ACC.utils.joinUrl(checkoutUrl, value);
							window.location.href = location;
                        }
                        if (key == 'errors') {
							if ($.inArray('checkout.multi.voucher.declined.message', value) !== -1) {
								window.location.href = invalidVoucherRedirectUrl;
							}
							else {
								/**
								 * If the response from the server contains an error, we hard
								 * refresh the page to allow the server to handle any re-directs.
								 */
								window.location.reload(true);
							}
                        }
					});

				}
			 });
		});

		if ($(".gift-card-number").is(":hidden")) {
			$(".gift-card-payment-buttons").show();
		}

	},

	savedCreditCard: function() {
		$(document).ready(function() {
			var $paymentInfoCard = $('.payment-info-card');
			var $radioInput = $paymentInfoCard.find('input[type="radio"]');

			if ($radioInput.hasClass('checked')) {
					$paymentInfoCard.attr('aria-checked', 'checked')
			}
		})

		$('.paymentList').on('click', '.payment-info-card', function() {
			var $thisList = $(this);
			var $radioInput = $thisList.find('input[type="radio"]');

			if ($radioInput.is(':checked')) {
				$thisList.attr('aria-checked', 'checked')
			}
		})

		$("#savedPaymentList .payment-info-card").find(".payment-info-expiry").each(function() {
			var $thisDiv = $(this);
			if($thisDiv.find('.expired').length){
				$thisDiv.closest('label').addClass('hideInput account-expired-card');
				if($thisDiv.closest('.payment-info-card').find('input').hasClass('checked')){
					var $newThis = $(this);
					$newThis.removeAttr('checked', 'checked');
					$newThis.prop('checked', false);
				}
			}
		});

		var $paymentCardInput = $(".payment-info-card-details"),
			$paymentNewCard = $(".payment-info-new-card"),
			$defaultCard = $(".payment-info-checkboxes .defaultCard"),
			$saveCard = $(".payment-info-checkboxes .saveCard"),
			$paymentCVV = $(".payment-info-cvv");


		$paymentCardInput.each(function(i) {
			function paymentBoxToggle(card) {
				card.addClass('checked').attr('checked', true);
				$saveCard.hide();
				$paymentCVV.show().removeClass('new-card-default-cvv');
			}

			($(this)).on('click', function(e) {
				ACC.gtm.trackCheckoutStepOptions('2', 'existing card');
			});

			if($(this).hasClass('payment-info-selected-card')){
				paymentBoxToggle($(this));
			} else {
				$(this).removeClass('checked').removeAttr('checked');
			}

			if ($(this).hasClass('payment-info-default-card') && $('.payment-info-selected-card').length == 0) {
				paymentBoxToggle($(this));
				$(this).addClass('payment-info-selected-card');
			}
		});

		if($('.payment-info-selected-card').hasClass('payment-info-default-card')) {
			$defaultCard.hide().removeClass('new-card-default');
		} else {
			$defaultCard.show().removeClass('new-card-default');
		}


		$('.payment-card-details:not(.payment-add-new-card, .account-expired-card)').on('click', function(){
			function paymentCheckedAttr() {
				$paymentNewCard.removeClass('checked').attr('checked', false);
				$paymentCardInput.removeClass('checked').attr('checked', false);
			}

			if ($(this).prev().hasClass('payment-info-default-card')) {
				paymentCheckedAttr();

				$defaultCard.hide().removeClass('new-card-default');
				$saveCard.hide();
				$paymentCVV.show().removeClass('new-card-default-cvv');

				$(this).prev().addClass('checked').attr('checked', true);
				$defaultCard.hide().removeClass('new-card-default-stored');
			} else {
				$paymentCardInput.removeClass('checked').attr('checked', false);
				paymentCheckedAttr();

				$defaultCard.show().removeClass('new-card-default');
				$saveCard.hide();
				$paymentCVV.show().removeClass('new-card-default-cvv');

				$(this).prev().addClass('checked').attr('checked', true);
				$defaultCard.show().addClass('new-card-default-stored');
			}
		});

		$paymentNewCard.on('click', function() {
			$paymentCardInput.removeClass('checked').attr('checked', false);
			$(this).prev().addClass('checked').attr('checked', true);
			if ($paymentCardInput.length === 0) {
				$defaultCard.hide().removeClass('new-card-default');
			} else {
				$defaultCard.show().addClass('new-card-default');
			}
			$saveCard.show().addClass('new-card-default-save');
			$paymentCVV.hide().addClass('new-card-default-cvv');

			ACC.gtm.trackCheckoutStepOptions('2', 'new card');
		});

		if($paymentNewCard.hasClass('checked')){
			if($paymentCardInput.length === 0){
				$defaultCard.hide().removeClass('new-card-default');
			} else {
				$defaultCard.show().addClass('new-card-default');
			}
			$(".payment-info-title").hide();
			$saveCard.show().addClass('new-card-default-save');
		}

		if($(".payment-info-card").hasClass('payment-option-disabled')) {
            $(".payment-info-title").show();
		}

		if($saveCard.hasClass('new-card-default-save')){
			$("#savedPaymentList").show();
		}

	},


	checkOutUrlChange : function() {
		var currentURL = $(location).attr('href');
		if (currentURL.toLowerCase().indexOf("apply-voucher") >= 0 ||
				currentURL.toLowerCase().indexOf("remove-voucher") >= 0 ||
				currentURL.toLowerCase().indexOf(
						"remove-checkbalance-giftCard") >= 0 ||
				currentURL.toLowerCase().indexOf("checkBalance-giftcard") >= 0 ||
				currentURL.toLowerCase().indexOf("apply-giftcard") >= 0 ||
				currentURL.toLowerCase().indexOf("remove-giftcard") >= 0) {
			var regex = new RegExp('/[^/]*$');
			if (typeof (history.pushState) != "undefined") {
				var obj = {
					Page : null,
					Url : currentURL.replace(regex, '/')
				};
				history
						.pushState(obj, obj.Page, currentURL
								.replace(regex, '/'));
			} else {
				console.log("Browser does not support HTML5.");
			}
		}
	},

	bindEnterEvent: function() {
	 	$('#j_password, #j_username').keypress(function(e){
			var $parentClass = $(this).closest(".form-group");
	        $parentClass.find('i').remove();
	        $parentClass.find('.help-block').remove();
			$parentClass.removeClass('has-error');

	        if(e.which == 13){//Enter key pressed
	            $('#checkoutLoginSubmit').click();//Trigger search button click event
	        }
	    });
	},

    /**
     * @description Prepares sessionStorage so that ACC.checkoutsteps.displayFlashBanner
     * can work properly for promo codes and any voucher (promo code, AD, gift card) removals.
     */
    bindVoucherChanges: function() {
		$('#tjxPromoForm[name="tjxPromoForm"').on('submit', function(e) {
            sessionStorage.setItem('displayBanner', 'promo');
		});

        $('.removeBtn').on('click', function(e) {
            sessionStorage.setItem('displayBanner', 'remove');
		});
    },

	bindGtmCheckoutSteps: function() {
		$('#tjxPromoForm').on('submit', function(e) {
			ACC.gtm.trackCheckoutStepOptions('2', 'Apply Promo Code');
		});

		$('#applyButton').on('click', function(e) {
			ACC.gtm.trackCheckoutStepOptions('2', 'add gift card');
		});

		$('#checkBalanceButton').on('click', function(e) {
			ACC.gtm.trackCheckoutStepOptions('2', 'check gift card balance');
		});

		$('#checkBalanceApplyButton').on('click', function(e) {
			ACC.gtm.trackCheckoutStepOptions('2', 'add gift card');
		});

	},

	bindGtmPaymentSteps: function() {
		$('#creditPayButton').on('click', function(e) {
			ACC.gtm.trackCheckoutStepOptions('3', 'Credit / Debit card');
		});
	},

    bindGaAddShippingInfo: ACC.gtmToGa.bindGaAddShippingInfo,
    bindGaAddPaymentInfo: ACC.gtmToGa.bindGaAddPaymentInfo,

	createSpinerContainer: function() {
		var $spinnerDiv = $("<div class='spinner-background'></div>").hide();
		$spinnerDiv.html("<div class='spinner'></div>");
		$('body').append($spinnerDiv);
	},
	showSpinnerContainer: function() {
		$(window).scrollTop(0);
        $('html').addClass('disable-scroll');
        $('.spinner-background').show();
	},
	hideSpinnerContainer: function() {
		$('html').removeClass('disable-scroll');
        $('.spinner-background').hide();
	},


	toggleCheckoutAriaControls: function() {
        var checkoutTabs = [].slice.call(document.querySelectorAll('[role="tab"]'));

        var customerTab = checkoutTabs[0];

        var guestTab = checkoutTabs[1];

        $(customerTab).click(function() {
            $(customerTab).attr('aria-selected', true);

            $(guestTab).attr('aria-selected', false);
        });

        $(guestTab).click(function() {
            $(customerTab).attr('aria-selected', false);

            $(guestTab).attr('aria-selected', true);
        });
    },

	/**
	 * @description reload Experian Search Address when submitting an incomplete form
	 */
	reloadExperianComponent: function() {
		var experianComponent = document.querySelector('[data-app]#experian-vue');
		experianComponent && window.reloadVueComponent(experianComponent);
	},

	/**
	 * @description takes an email as a parameter and returns the experian API response
	 * @param {string} email
	 * @returns {Promise}
	 */
	experianAPICall: async function(email){
		const isExtEmailValidationDone = document.getElementById("isExtEmailValidationDone");
		const extEmailValidationConfidence = document.getElementById("extEmailValidationConfidence");
		const extEmailValidationVerboseOutput = document.getElementById("extEmailValidationVerboseOutput");
		const extEmailValidationAPIErrorDetails = document.getElementById("extEmailValidationAPIErrorDetails");

		const validateResult = await window.ACC.emailValidator.validate(email);
		ACC.checkout.handleExperianEmailSuggestions(validateResult);

		if(validateResult?.status === 200){
			extEmailValidationConfidence.value = validateResult?.data?.result?.confidence;
			extEmailValidationVerboseOutput.value = validateResult?.data?.result?.verbose_output;
			extEmailValidationAPIErrorDetails.value = '';
		}
		else if(validateResult?.status >= 400 && validateResult?.status < 600){
			isExtEmailValidationDone.value = true;
			extEmailValidationAPIErrorDetails.value = `API-URL:${window.ACC.externalEmailValidationConfig.API_URL}, Status:${validateResult?.status}, Error_title:${validateResult?.data?.error?.title}, Error_details:${validateResult?.data?.error?.detail}`;
		}
	},

	/**
	 * @description takes Experian API data and handles buttons & suggestion UI
	 * @param {object} APIData Experian API response data
	 */
	handleExperianEmailSuggestions: function(APIData){
		const apiConfidenceValue = APIData?.data?.result?.confidence;
		const apiDidYouMeanValue = APIData?.data?.result?.did_you_mean;

		const validResponses = apiConfidenceValue === "verified" || apiConfidenceValue === "unknown";
		const invalidResponses = apiConfidenceValue === "unreachable" || apiConfidenceValue === "undeliverable" || apiConfidenceValue === "illegitimate" || apiConfidenceValue === "disposable";

		// Handle valid responses
		if (validResponses) {
			// Displays tick icon only if regex and API response confidence value is verified
			const $emailInputParentClass = $("#j_username").closest(".form-group");
			$emailInputParentClass.prepend('<i class="tick icon icon-check-circle"></i>');

			if (apiDidYouMeanValue) {
				ACC.checkout.handleValidResponseWithSuggestion(apiDidYouMeanValue);
				ACC.checkout.handleExperianEmailButtons(apiDidYouMeanValue);
			}
		// Handle invalid responses
		} else if (invalidResponses){
			if (apiDidYouMeanValue) {
				ACC.checkout.handleInvalidResponseWithSuggestion(apiDidYouMeanValue);
				ACC.checkout.handleExperianEmailButtons(apiDidYouMeanValue);
			}
			else {
				ACC.checkout.handleInvalidResponseWithoutSuggestion();
				ACC.checkout.handleExperianEmailButtons();
			}
		}
	},

	handleValidResponseWithSuggestion: function (apiDidYouMeanValue){
		const apiEmailField = document.getElementById("api-email");
		const didYouMeanField = document.getElementById("didYouMeanField");
		const didYouMeanFieldMsgPrompt = document.getElementById("suggestedEmailPrompt");
		const emailValidationBtns = document.getElementById("emailValidationsBtns");
		const keepEmailBtn = document.getElementById("keepEmailBtn");
		const suggestedEmailBtn = document.getElementById("suggestEmailBtn");

		apiEmailField.innerHTML = apiDidYouMeanValue[0];
		didYouMeanField?.classList.remove("hidden");
		emailValidationBtns?.classList.remove("hidden");
		didYouMeanFieldMsgPrompt?.classList.remove("hidden");

		// Unfocussing the keepEmail button for NVDA screen reader
		keepEmailBtn.blur();
    	suggestedEmailBtn.focus();
	},

	handleInvalidResponseWithoutSuggestion: function (){
		const keepEmailBtn = document.getElementById("keepEmailBtn");
		const suggestedEmailBtn = document.getElementById("suggestEmailBtn");
		const emailValidationBtns = document.getElementById("emailValidationsBtns");

		const errorMsgBox = document.getElementById("experianEmailValidationErrorMsg");
		const errorMsgValueField = document.getElementById("expApiMsgBox");
		const emailSuggestionQuestion = document.getElementById("emailSuggestionQuestion");

		// Display error msg without suggestion
		errorMsgValueField.innerHTML = window.ACC.externalEmailValidationConfig.ERROR_NO_SUGGESTOIN;
		emailSuggestionQuestion?.classList.add("hidden");
		errorMsgBox?.classList.remove("hidden");

		// Display only Keep email btn
		emailValidationBtns?.classList.remove("hidden");
		suggestedEmailBtn?.classList.add("hidden");

		keepEmailBtn.focus();
		ACC.checkout.handleExperianEmailButtons();
	},

	handleInvalidResponseWithSuggestion: function (apiDidYouMeanValue){
		const emailValidationBtns = document.getElementById("emailValidationsBtns");
		const errorMsgBox = document.getElementById("experianEmailValidationErrorMsg");
		const errorMsgValueField = document.getElementById("expApiMsgBox");
		const keepEmailBtn = document.getElementById("keepEmailBtn");
		const suggestedEmailBtn = document.getElementById("suggestEmailBtn");

		// Display error msg with suggestion
		errorMsgValueField.innerHTML = window.ACC.externalEmailValidationConfig.ERROR_WITH_SUGGESTOIN;
		errorMsgBox?.classList.remove("hidden");

		// Display suggested email
		const sugEmail = document.querySelector("#apiSuggestedEmail");
		sugEmail.innerHTML = apiDidYouMeanValue[0];

		// Show both suggested btn & keep email button
		emailValidationBtns?.classList.remove("hidden");

		// Unfocussing the keepEmail button for NVDA screen reader
		keepEmailBtn.blur();
    	suggestedEmailBtn.focus();

		// Handle Experian API Email Buttons
		ACC.checkout.handleExperianEmailButtons(apiDidYouMeanValue);
	},

	/**
	 * @description Handle Experian API Email Buttons
	 */
	handleExperianEmailButtons: function(didYouMeanVal = null){
		const emailInput = document.querySelector("#j_username");
		const suggestedEmailBtn = document.getElementById("suggestEmailBtn");
		const keepEmailBtn = document.getElementById("keepEmailBtn");

		suggestedEmailBtn?.addEventListener('click', function(event) {
			// Removes tick icon if the API resonse confidence value of the email is invalid
			const $parentClassIcon = $("#j_username").closest(".form-group");
			if ($parentClassIcon.find('i').length > 0){$parentClassIcon.find('i').remove();}

			if (didYouMeanVal){
				emailInput.value = didYouMeanVal[0];
			}
			const email = emailInput.value.trim();

			ACC.checkout.clearAPISuggestions();
			ACC.checkout.experianAPICall(email);
			ACC.checkout.handleExperianEmailValidation();
		});
		keepEmailBtn?.addEventListener('click', function(event) {
			ACC.checkout.clearAPISuggestions();
		});
	},

	/**
	 * @description Clears Experian API suggestions UI
	 */
	clearAPISuggestions: function(){
		const didYouMeanField = document.getElementById("didYouMeanField");
		const emailValidationBtns = document.getElementById("emailValidationsBtns");
		const errorMsgBox = document.getElementById("experianEmailValidationErrorMsg");
		const suggestedEmailBtn = document.getElementById("suggestEmailBtn");
		const emailSuggestionQuestion = document.getElementById("emailSuggestionQuestion");
		const errorMsgSuggestedEmail = document.querySelector("#apiSuggestedEmail");

		didYouMeanField?.classList.add("hidden");
		emailValidationBtns?.classList.add("hidden");
		errorMsgBox?.classList.add("hidden");
		suggestedEmailBtn?.classList.remove("hidden");
		emailSuggestionQuestion?.classList.remove("hidden");
		errorMsgSuggestedEmail.innerHTML = '';
	},

	bindEmailMarketingPreferences: function () {		
		function getCheckboxValue (checkboxId) {
			return document.getElementById(checkboxId)?.checked;
		}
		const tkmaxxCheckbox = document.getElementById('tkmaxxPreferences');
		const homesenseCheckbox = document.getElementById('homesensePreferences');
        function updateEmailMarketingSignup(emailmktgSignup, isPageLoad) {
			const global = JSON.parse(localStorage.getItem("gtm.global") || '{}');
			const pageName = global.page_name || global.pageName;

			const value = sessionStorage.getItem('page_name');
			global.emailmktgSignup = value;
			const validSession = value === null || value === "false" || value === 'Checkout_Page';
			if(isPageLoad && (tkmaxxCheckbox || homesenseCheckbox) && validSession) {
                sessionStorage.removeItem('page_name');
                sessionStorage.setItem('isSubscribed', false);
                global.emailmktgSignup = "false";
            } else if (validSession && pageName?.includes('checkout')) {
                if (emailmktgSignup === "false" || emailmktgSignup === null){
                    sessionStorage.removeItem('page_name');
                } else {
                sessionStorage.setItem('page_name', emailmktgSignup);
                }
                global.emailmktgSignup = emailmktgSignup;
            }
			window.ACC?.ga?.dispatchDataEvents(global);
			if ((global.emailmktgSignup === 'Checkout_Page' || global.emailmktgSignup === 'Guest_Checkout') && pageName?.includes('checkout')){
			ACC.gtm?.trackEmailMktgSignup(global.emailmktgSignup);
			}
		}

		function saveCheckboxStates(isChangeChedcked =false) {
			// Save the current checkbox states to localStorage
			sessionStorage.setItem('isSubscribed', isChangeChedcked);
		}
		const isSubscribed = JSON.parse(sessionStorage.getItem('isSubscribed'));
		const emailmktgSignup = (getCheckboxValue('tkmaxxPreferences') || getCheckboxValue('homesensePreferences') || isSubscribed) ? 'Checkout_Page' : "false";
    	updateEmailMarketingSignup(emailmktgSignup, true);


		function handlePreferencesChange(e) {
			const isChecked = e.target?.checked;
			const isChangeChecked = (isChecked || getCheckboxValue('tkmaxxPreferences') || getCheckboxValue('homesensePreferences'));
			const emailmktgSignup = isChangeChecked ? 'Checkout_Page' : "false";
			saveCheckboxStates(isChangeChecked);
			updateEmailMarketingSignup(emailmktgSignup, false);
		}

		if (tkmaxxCheckbox) {
			tkmaxxCheckbox.addEventListener('change', function(e) {
				handlePreferencesChange(e);
			});
		}
		if (homesenseCheckbox) {
			homesenseCheckbox.addEventListener('change', function(e) {
				handlePreferencesChange(e);
			});
		}
    },

	/**
	 * @description Handle Experian API Email Validation
	 */
	handleExperianEmailValidation: async function(){
		const emailInput = document.querySelector("#j_username");
		const checkoutLoginSubmit = document.querySelector("#checkoutLoginSubmit");
		const isExtEmailValidationDone = document.getElementById("isExtEmailValidationDone");

		if (window.ACC.externalEmailValidationConfig.ENABLED === 'true'){
			isExtEmailValidationDone.value = true;
			ACC.checkout.clearAPISuggestions();
			const email = emailInput.value.trim();
			await ACC.checkout.experianAPICall(email);
			checkoutLoginSubmit.removeAttribute('disabled');
		}
		else if (window.ACC.externalEmailValidationConfig.ENABLED === 'false'){
			isExtEmailValidationDone.value = false;
		}
	}
};
